/**完成订单 评价订单**/
<template>
  <div class="informTimeMod">
    <div class="dialogueModContent">
      <div class="contentTime">
        <span class="time">
          {{timeFn}}
          <!--<span class="hasRead"></span>-->
        </span>
      </div>
      <div class="ContentMid clear">
        <div class="midLeft">
                <span class="leftImg">
                  <img :src="logo" alt="LOGO">
                </span>
        </div>
        <div class="midRight">
          <span class="rightArrows"></span>
          <div class="rightContent">
            {{content}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Toucth from '../../../../assets/js/method'
  import { mapGetters } from 'vuex'

  export default {
    name: 'xk-informTimeMod',
    props: ['time', 'content'],
    computed: {
      ...mapGetters({
        companyInfo: 'companyInfo'
      }),
      timeFn: function () {
        return Toucth.TimestampDate(this.$props.time)
      }
    },
    data () {
      return {
        logo: ''
      }
    },
    methods: {},
    watch: {
      companyInfo: function (val) {
        if (val) {
          this.logo = window.configure.imgUrl + val.logo
        }
      }
    },
    mounted: function () {
      this.logo = window.configure.imgUrl + this.companyInfo.logo
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .informTimeMod {
    padding: 0 1rem;
    .contentTime {
      width: 100%;
      text-align: center;
      margin-top: 1.66666rem;
      margin-bottom: 0.833333rem;
      .time {
        display: inline-block;
        height: 1.25rem;
        line-height: 1.25rem;
        border-radius: 0.625rem;
        font-size: 0.83333rem;
        color: #fff;
        padding: 0 0.5rem;
        text-align: center;
        background: #cccccc;
        position: relative;
        .hasRead {
          position: absolute;
          right: 0;
          top: 0;
          width: 0.5rem;
          height: 0.5rem;
          background: #f06553;
          z-index: 10;
          border-radius: 50%;
        }
      }
    }
    .ContentMid {
      .midLeft {
        float: left;
        width: 3.3333rem;
        height: 3.3333rem;
        border-radius: 50%;
        overflow: hidden;
        position: relative;
        .leftImg {
          width: 100%;
          height: 100%;
        }
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .midRight {
        float: left;
        display: inline-block;
        max-width: calc(~'100% - 4.8rem');
        margin-left: 1.3rem;
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 1rem;
        background: #fff;
        position: relative;
        .rightArrows {
          position: absolute;
          left: -0.66rem;
          top: 0.6rem;
          background: url(../../../../assets/img/inform/arrows.png) no-repeat;
          width: 0.93333rem;
          height: 1.141666rem;
        }
        .rightContent {
          width: 100%;
          box-sizing: border-box;
          word-wrap: break-word;
          display: inline-block;
          line-height: 1.6666rem;
          padding: 1rem 0.9rem;
          font-size: 1rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// informTimeMod.vue?71744de6